import { request } from '@/shared/api/request'

export const getAccident = (externalId) => {
	return request({ url: 'safety/accident/' + externalId, method: 'GET' })
}
